import { render, staticRenderFns } from "./CardSplit.vue?vue&type=template&id=51bc255d&scoped=true"
import script from "./CardSplit.js?vue&type=script&lang=js&external"
export * from "./CardSplit.js?vue&type=script&lang=js&external"
import style0 from "./CardSplit.vue?vue&type=style&index=0&id=51bc255d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc255d",
  null
  
)

export default component.exports